import { Add, Delete, WarningTwoTone } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  FormControl,
  FormControlLabel,
  Grid,
  Grow,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Switch,
  TextField,
} from "@mui/material";
import React from "react";
import { useContext } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import { useForm } from "../../../hooks";
import { OrdiniRitiroContext } from "../../../context";

const MerceADR = ({ scrollOnBott, mainForm, setMainForm, formAutomatico = {} }) => {
  const [checked, setChecked] = useState(mainForm.sceltaADR);

  //13/08/2026 Greg: quando il ritiro arriva da un Preventivo, la merce ADR è già
  //quella su cui è stata calcolata la tariffa: la sezione resta visibile/compilata
  //ma non editabile dall'utente.
  const compilatoDaformAutomatico = formAutomatico && Object.keys(formAutomatico).length > 0;

  const [merceAdrForm, setMerceAdrForm] = useState(
    formAutomatico.ordadr && formAutomatico.ordadr.length > 0
      ? formAutomatico.ordadr.map((r) => ({ ...r, id: r.id || uuidv4() }))
      : [
          {
            id: uuidv4(),
            Classe: "-1",
            Imballaggio: "-1",
            NumONU: "",
            Descrizione: "",
            Colli: "",
            Peso: "",
          },
        ]
  );

  const {
    values: merceADRForm,
    changeHandler,
    setValues,
  } = useForm(
    {
      ordadr: formAutomatico.ordadr || [],
    },
    []
  );

  useEffect(() => {
    if (formAutomatico.ordadr && formAutomatico.ordadr.length > 0) {
      setChecked(true);
    }
  }, []);

  useEffect(() => {
    if (!checked && !(formAutomatico.ordadr && formAutomatico.ordadr.length > 0)) {
      changeHandler("ordadr", []);
    }
    //scrollOnBott(checked);
    setValues({ ...merceADRForm, sceltaADR: checked });
  }, [checked]);

  useEffect(() => {
    //11/08/2026 Greg: uso l'updater funzionale (come DettaglioMisureMerce) invece di
    //spreaddare "mainForm" (chiusura stale). Quando l'ordine arriva da un Preventivo,
    //più sezioni montano insieme e ognuna lancia il proprio effect one-shot su
    //setMainForm nello stesso batch: usando un valore semplice, l'ultima chiamata
    //vince e le altre (incluso ordadr) venivano perse.
    setMainForm(prev => ({ ...prev, ordadr: merceADRForm.ordadr}));
  }, [merceADRForm]);

  const {
    state: { adrClassi, adrImballaggi },
    getClassi,
    getImballaggi,
  } = useContext(OrdiniRitiroContext);

  useEffect(() => {
    getClassi();
    getImballaggi();
  }, []);

  const addMerceAdr = () => {
    setMerceAdrForm([
      ...merceAdrForm,
      {
        id: uuidv4(),
        Classe: "-1",
        Imballaggio: "-1",
        NumONU: "",
        Descrizione: "",
        Colli: "",
        Peso: "",
      },
    ]);
  };

  const cancellaInserimento = (id) => {
    setMerceAdrForm([...merceAdrForm.filter((res) => res.id !== id)]);
  };

  const handelChangeValue = (key, value, index, row) => {
    let arrayData = [...merceAdrForm.filter((res) => res.id !== row.id)];
    arrayData.splice(index, 0, { ...merceAdrForm[index], [key]: value });
    setMerceAdrForm(arrayData);
    changeHandler("ordadr", arrayData);
  };

  return (
    <Card
      elevation={0}
      sx={{ background: (theme) => theme.palette.info.main + "20" }}
    >
      <CardHeader
        title={"Merce ADR"}
        subheader={""}
        subheaderTypographyProps={{
          fontWeight: "bold",
        }}
        titleTypographyProps={{
          fontWeight: "bold",
          fontSize: 18,
        }}
        avatar={<WarningTwoTone />}
        action={
          <Stack direction={"row"} spacing={2}>
            <FormControlLabel
              control={
                <Switch
                  checked={checked}
                  disabled={compilatoDaformAutomatico}
                  onClick={() => setChecked(!checked)}
                />
              }
              label=""
            />
          </Stack>
        }
      />
      {checked ? (
        <Grow in={checked} timeout={{ appear: 1000, enter: 1000, exit: 1000 }}>
          <CardContent>
            {merceAdrForm.map((res, i) => {
              return (
                <Grid item container spacing={1} key={i}>
                  <Grid item xs={12} md={1} lg={1} mr={-5} mt={2}>
                    <IconButton
                      onClick={() => cancellaInserimento(res.id)}
                      color="error"
                      disabled={compilatoDaformAutomatico}
                    >
                      <Delete />
                    </IconButton>
                  </Grid>
                  <Grid item xs={12} md={2} lg={2} mt={2}>
                    <FormControl fullWidth>
                      <InputLabel id="select-from-nations">Classe</InputLabel>
                      <Select
                        fullWidth
                        size="small"
                        labelId="select-from-nations"
                        id="select-from-nations"
                        value={res.Classe || ""}
                        defaultValue={-1}
                        disabled={compilatoDaformAutomatico}
                        onChange={(e) =>
                          handelChangeValue("Classe", e.target.value, i, res)
                        }
                        label="Classe"
                      >
                        <MenuItem value={"-1"}>Seleziona classe</MenuItem>
                        {adrClassi.map((data, index) => {
                          return (
                            <MenuItem value={data.codice} key={index}>
                              {data.descrizione}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={2} lg={2} mt={2}>
                    <FormControl fullWidth>
                      <InputLabel id="select-from-nations">
                        Imballaggi
                      </InputLabel>
                      <Select
                        fullWidth
                        size="small"
                        labelId="select-from-nations"
                        id="select-from-nations"
                        value={res.Imballaggio || ""}
                        disabled={compilatoDaformAutomatico}
                        onChange={(e) =>
                          handelChangeValue(
                            "Imballaggio",
                            e.target.value,
                            i,
                            res
                          )
                        }
                        label="Imballaggi"
                      >
                        <MenuItem value={"-1"}>Seleziona imballaggi</MenuItem>
                        {adrImballaggi.map((data, index) => {
                          return (
                            <MenuItem value={data.codice} key={index}>
                              {data.descrizione}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} md={1} lg={1}>
                    <TextField
                      margin="normal"
                      fullWidth
                      size="small"
                      label="n° ONU"
                      autoComplete="off"
                      value={res.NumONU || ""}
                      disabled={compilatoDaformAutomatico}
                      onChange={(e) =>
                        handelChangeValue("NumONU", e.target.value, i, res)
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={3} lg={3}>
                    <TextField
                      margin="normal"
                      fullWidth
                      size="small"
                      label="Descrizione"
                      autoComplete="off"
                      value={res.Descrizione || ""}
                      disabled={compilatoDaformAutomatico}
                      onChange={(e) =>
                        handelChangeValue("Descrizione", e.target.value, i, res)
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={1} lg={1}>
                    <TextField
                      margin="normal"
                      fullWidth
                      size="small"
                      label="Colli"
                      autoComplete="off"
                      value={res.Colli || ""}
                      disabled={compilatoDaformAutomatico}
                      onChange={(e) =>
                        handelChangeValue("Colli", e.target.value, i, res)
                      }
                    />
                  </Grid>

                  <Grid item xs={12} md={2} lg={2}>
                    <TextField
                      margin="normal"
                      fullWidth
                      size="small"
                      label="Peso"
                      autoComplete="off"
                      value={res.Peso || ""}
                      disabled={compilatoDaformAutomatico}
                      onChange={(e) =>
                        handelChangeValue("Peso", e.target.value, i, res)
                      }
                    />
                  </Grid>
                </Grid>
              );
            })}
            <CardActions sx={{ justifyContent: "right", direction: "row" }}>
              <Stack direction={"row"}>
                <Button variant="contained" color="primary" startIcon={<Add />} onClick={() => addMerceAdr()} disabled={compilatoDaformAutomatico}>
                  {" "}
                  Aggiungi
                </Button>
              </Stack>
            </CardActions>
          </CardContent>
        </Grow>
      ) : (
        <></>
      )}
    </Card>
  );
};

export default MerceADR;
